'use strict';

export default {
  computed: {
    currentSubjectCondition() {
      return this.$store.state.top.currentSubjectCondition;
    },
  },
}
